export const linesNamePrefix = 'lines';
export const fieldMinHeight = 28;
